
(() => {
  if (customElements.get('poltzaa-cart-discount')) return;

  class PoltzaaCartDiscount extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      const form = this.querySelector('[data-poltzaa-discount-form]');
      const input = this.querySelector('#PoltzaaDiscountCode');
      const message = this.querySelector('[data-poltzaa-discount-message]');
      const button = form?.querySelector('button[type="submit"]');

      if (!form || !input || !message || !button) return;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const code = input.value.trim();

        if (!code) {
          this.showMessage('Please enter a discount code.', true);
          return;
        }

        button.disabled = true;
        button.textContent = 'Applying…';
        this.showMessage('Applying your discount…');

        try {
          // Ask Shopify to apply the discount without navigating the page.
          const discountResponse = await fetch(
            `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/')}`,
            {
              method: 'GET',
              credentials: 'same-origin',
              redirect: 'follow',
              headers: { Accept: 'text/html' }
            }
          );

          if (!discountResponse.ok) {
            throw new Error('Shopify could not process this request.');
          }

          // Refresh Dawn's drawer and header cart bubble.
          const sectionsResponse = await fetch(
            '/?sections=cart-drawer,cart-icon-bubble',
            {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' }
            }
          );

          if (!sectionsResponse.ok) {
            throw new Error('The cart refresh failed.');
          }

          const sections = await sectionsResponse.json();
          const drawer = document.querySelector('cart-drawer');

          if (
            !sections['cart-drawer'] ||
            !sections['cart-icon-bubble'] ||
            !drawer ||
            typeof drawer.renderContents !== 'function'
          ) {
            throw new Error('The cart sections could not be refreshed.');
          }

          drawer.renderContents({ sections });

          this.showMessage(
            'Discount request processed. Check the refreshed cart and checkout to confirm the offer.'
          );
        } catch (error) {
          console.error('POLTZAA discount error:', error);
          this.showMessage(
            'We could not refresh the cart automatically. Your existing cart is unchanged; please verify the discount at checkout.',
            true
          );
        } finally {
          button.disabled = false;
          button.textContent = 'Apply';
        }
      });
    }

    showMessage(text, isError = false) {
      const message = this.querySelector('[data-poltzaa-discount-message]');
      if (!message) return;

      message.textContent = text;
      message.classList.toggle('is-error', isError);
      message.hidden = false;
    }
  }

  customElements.define('poltzaa-cart-discount', PoltzaaCartDiscount);
})();
